import React from "react";
import { Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import LogoIcon from "../../images/companylogo.png";

interface MobileHeaderProps {
  onMenuToggle: () => void;
  isMenuOpen: boolean;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  onMenuToggle,
  isMenuOpen,
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "black",
        height: "56px",
        px: 2,
        position: "sticky",
        top: 0,
        zIndex: 1100,
      }}
    >
      {/* Logo */}
      <Box
        onClick={() => navigate("/dashboard")}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <img
          src={LogoIcon}
          alt="Logo"
          style={{
            width: "36px",
            height: "36px",
            borderRadius: "50%",
          }}
        />
      </Box>

      {/* Menu Toggle Button */}
      <IconButton
        onClick={onMenuToggle}
        sx={{
          color: "white",
          minWidth: "44px",
          minHeight: "44px",
        }}
        aria-label={isMenuOpen ? "Close menu" : "Open menu"}
      >
        {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
      </IconButton>
    </Box>
  );
};

export default MobileHeader;
